<p-panel class="our-form-background">
  <ng-template pTemplate="header" class="eca-secondary-bg" style="color: white">
    <h3 style="margin-top: 5px;">
      <span style="margin-left: 15px;">
        <fa-icon style="margin-right: 5px"
                 [icon]="['fas', 'book']"> </fa-icon> <span class="hide-on-small-screens">Observation For -</span> <span *ngIf="observationSummary"> {{this.observationTitle}}</span>
      </span>
    </h3>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <app-detail-container #observationDetailsContainerComponent [containerHeader]="observationDetailsContainerHeader"
                                [collapsedContainerHeader]="observationDetailsCollapsedContainerHeader"
                                [containerHeaderAction]="observationDetailsAction">
            <ng-template #observationDetailsContainerHeader>
              Observation Details
            </ng-template>

            <ng-template #observationDetailsCollapsedContainerHeader>
              <span class="hide-on-small-screens">Observation Details -</span> {{observationSummary.summaryInfo}}
            </ng-template>

            <ng-template #observationDetailsAction>

              <span class="float-right">
                <app-eca-ghost-btn btnText="Preview" btnType="success" btnIcon="search"
                                   *ngIf="observationSummary?.canPreviewDocument && !isEditing"
                                   (btnClicked)="openOperativeDocument()">
                </app-eca-ghost-btn>
                <app-eca-ghost-btn class="title-action-button" *ngIf="!isEditing" btnText="Edit" (btnClicked)="editDetails()"
                                   btnIcon="edit" btnType="primary"></app-eca-ghost-btn>
                <app-eca-ghost-btn *ngIf="isEditing" btnText="Save" btnIcon="save" btnType="success"
                                   (btnClicked)="saveDetails()"></app-eca-ghost-btn>
                <app-eca-ghost-btn *ngIf="isEditing" btnText="Cancel" btnIcon="times" btnType="danger"
                                   (btnClicked)="cancelEdit()"></app-eca-ghost-btn>
              </span>
            </ng-template>
            <div class="row">
              <div class="col">
                <div class="container-fluid " style="margin-bottom: 20px">
                  <app-observation-form *ngIf="!isObservationLoading" [saveAttempted]="saveAttempted" [observation]="tempObservation" [isEditing]="isEditing"> </app-observation-form>

                </div>
              </div>
            </div>
          </app-detail-container>
        </div>
      </div>
    </div>

    <div class="container-fluid" style="margin-top: 1rem; margin-bottom: 200px; min-height: 400px">
      <div class="row">
        <div class="col">
          <p-tabView #memberTabs [styleClass]="'eca-tabs'">
            <p-tabPanel>
              <ng-template pTemplate="header">
                <i class='fas fa-file'></i>
                <span class="tab-title">Documents</span>
              </ng-template>
              <div class="row">
                <div class="col-12">
                  <div *ngIf="isObservationLoading" class="text-center">
                    <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
                  </div>
                  <div *ngIf="!isObservationLoading">
                    <app-documents-list [showCount]="true" [allowedOperations]="loggedInUser?.documentOperations"
                                        [headerText]="'Documents'"
                                        [addDocumentButtonText]="'Add'" [documents]="observationDocuments"
                                        [showTableCaption]="true" (addDocument)="addObservationDocument()"
                                        (downloadDocument)="downloadObservationDocument($event)"
                                        (viewDocument)="viewObservationDocument($event)"
                                        (deleteDocument)="deleteObservationDocumentClick($event)"
                                        (editDocument)="editObservationDocument($event)"
                                        (openDocument)="openObservationDocument($event)" (refreshDocumentsRequested)="getObservationDocuments($event)">

                    </app-documents-list>
                  </div>
                </div>
              </div>
            </p-tabPanel>
          </p-tabView>
        </div>
      </div>
    </div>
  </ng-template>
</p-panel>
